
<div *ngIf="loadAppRequest" >
    <p-progressBar  class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
   
</div>



<div class="container-fluid" style="width:99%">
    <div class="row" > 
   
    <div class="col-md-3">

<p-table #dt (onRowSelect)="onRowSelect()" [columns]="cols" [responsive]="true" [scrollable]="true" scrollHeight="380px" [rows]="8" [value]="publicApi" selectionMode="single" [(selection)]="selectedApi" dataKey="id">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th >
              
               <label for="api">APIs</label>
               <span  class="badge badge-pill badge-primary">production</span>

               <br>
               <input  id="api"  pInputText type="text"
                        (input)="dt.filter($event.target.value, 'apiName', 'contains')" placeholder="Search"/>
               
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" *ngIf="rowData['path'].indexOf('production') > -1 && !(rowData.apiName=='FHIR Server PKCE API Provider' || 
                                                                                              rowData.apiName=='FHIR Mobile PKCE API Provider') ">
            <td class="font-weight-bold" style="word-break: break-all" >
              
            
               {{rowData['apiName'] }}  
               
              
            </td>
        </tr>
    </ng-template>
    
</p-table>


</div>
    <div class="col-md-9"  >
       
         <div  #details tabindex="-1">
         
                         
            <div *ngIf="selectedApi ? true:false" style="text-align: left"  >
                <p-card>  
                <div  >
                     <br>              
                    <h2 class="aetna-header" style="color: #7d3f98">{{selectedApi.apiName}}  
                   </h2>
                
                    <hr>
                 <!--   <div class="aetna-p" [innerHTML]="selectedApi.description"></div>-->
                        <div class="aetna-p">Select Swagger Specification below for API details.</div>
                    <br>
             <!--
                    <div class="container-fluid">
                        <div class="row">
                          <div class="col-md-9" >
                              <h2 class="aetna-header"  style="color: #7d3f98" *ngIf="selectedApi.apiName.indexOf('patientaccess') > -1 || selectedApi.apiName.indexOf('providerdirectory') > -1"> Security</h2>
                              <hr *ngIf="selectedApi.apiName.indexOf('patientaccess') > -1 || selectedApi.apiName.indexOf('providerdirectory') > -1">
                                 <p class="aetna-p" *ngIf="selectedApi.apiName.indexOf('patientaccess') > -1">Oauth2 Access Code</p>
                              <ul class="center aetna-p" *ngIf="selectedApi.apiName.indexOf('patientaccess') > -1"> 
                              
                                <li>Scopes
                                <ul>
                                <li>patient/*.read</li>
                                <li>patient/*.*</li>
                              </ul>
                            </li>
                              </ul>
                              <p class="aetna-p" *ngIf="selectedApi.apiName.indexOf('providerdirectory') > -1">Oauth2 Application
                              </p>
                              <ul class="center aetna-p" *ngIf="selectedApi.apiName.indexOf('providerdirectory') > -1"> 
                              
                                <li>Scopes
                                <ul>
                                <li>Public</li>
                                <li>NonPII</li>
                              </ul>
                            </li>
                            </ul>
                    
                          </div>
                        </div>
                    </div>   
                -->
                    <br>
                    <h2 class="aetna-header" style="color: #7d3f98">View Swagger</h2>
                    
                
                    <hr>
                    <table  style="width: 80%;">
                        <tr>
                            <td>
                                <div *ngIf="showLink"> 
                                <button #myButton style="font-size: 16px;" pButton (click)="viewSwagger()"  label="Swagger Specification"   class="aetna-button ui-button-raised ui-button-rounded"></button>
                               </div>
                            </td>
                            <td>
                                <div *ngIf="showLink"> 
                                   
                                    <i class="pi pi-download" style="font-size: 1.4em"></i>
                                    <a class="aetnaMainDiv" [href]="downloadJsonHref" download="{{downloadFileName}}"><u>Download Swagger File.</u></a> 
                               </div>
                              
                            </td>
                            <td></td>
                           
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                
                                <div *ngIf="showCRDCompanionGuide">
                                    <i class="pi pi-file-pdf" style="font-size: 1.4em; color: red;"></i>
                                    <a class="aetnaMainDiv" [href]="aetnaCRDCompanionGuideUrl" target="_blank">
                                        <u>Aetna CRD Companion Guide.pdf</u>
                                    </a>
                                </div>
                            </td>
                       
                            <td>
                                
                                <div *ngIf="showPASCompanionGuide">
                                    <i class="pi pi-file-pdf" style="font-size: 1.4em; color: red;"></i>
                                    <a class="aetnaMainDiv" [href]="aetnaPASCompanionGuideUrl" target="_blank">
                                        <u>Aetna PAS Companion Guide.pdf</u>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        
                    </table>
                                     
                   
                 

                    
                   <br>
                   <br>
                </div>
                </p-card>
            </div>
        </div> 
    </div>
</div>
</div>   


